import React, { useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from './Login.module.css';
import { FormikTextField } from '../../components/form-components/common-components/text-field/FormikTextField';
import * as Yup from 'yup';
import { useStore } from '../../hooks/useStore';
import { LoginRequest } from '../../models/user/UserModels';
import { FormControlLabel, Checkbox, Box } from '@mui/material';
import KaldenLogo from '../../assets/kalden-logo.png';

const LoginSchema = Yup.object().shape({
  username: Yup.string().required('Kullanıcı adı zorunlu'),
  password: Yup.string().required('Şifre zorunlu'),
  rememberMe: Yup.boolean(),
});

export const Login: React.FC = () => {
  const { authStore } = useStore();
  const navigate = useNavigate();

  // Sayfa yüklendiğinde localStorage'dan kullanıcı adını al
  useEffect(() => {
    const rememberedUsername = localStorage.getItem('rememberedUsername');
    if (rememberedUsername) {
      // Formik'in initialValues'ını güncellemek için bir state kullanacağız
      setInitialValues(prev => ({
        ...prev,
        username: rememberedUsername,
        rememberMe: true,
      }));
    }
  }, []);

  const [initialValues, setInitialValues] = React.useState({
    username: '',
    password: '',
    rememberMe: false,
  });

  const handleSubmit = async (values: LoginRequest & { rememberMe: boolean }) => {
    try {
      const { rememberMe, ...loginData } = values;

      if (rememberMe) {
        localStorage.setItem('rememberedUsername', values.username);
      } else {
        localStorage.removeItem('rememberedUsername');
      }

      const response: any = await authStore.login(loginData, rememberMe);
      if (response.error == true) {
        toast.error(response.message || '');
        return;
      }
      if (!response.error && response.value && response.value.jwtToken) {
        toast.success(response.message || 'Giriş başarılı');
        navigate('/desing-system');
      } else {
        toast.error(response.message || 'Giriş başarısız');
      }
    } catch (error) {
      toast.error('Giriş işlemi sırasında bir hata oluştu');
    }
  };

  return (
    <div className={styles.container}>
      <img src={KaldenLogo} alt="Kalden Logo" className={styles.logo} />
      <div className={styles.formWrapper}>
        <h1 className={styles.title}>Giriş Yap</h1>
        <Formik
          initialValues={initialValues}
          validationSchema={LoginSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, values, setFieldValue }) => (
            <Form className={styles.form}>
              <FormikTextField
                name="username"
                label="Kullanıcı Adı"
                type="text"
                placeholder="Kullanıcı adınızı giriniz"
                disableUppercase={true}
              />
              <FormikTextField
                name="password"
                label="Şifre"
                type="password"
                placeholder="Şifrenizi giriniz"
                disableUppercase={true}
              />
              <Box sx={{ mb: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.rememberMe}
                      onChange={e => setFieldValue('rememberMe', e.target.checked)}
                      name="rememberMe"
                      color="primary"
                    />
                  }
                  label="Beni Hatırla"
                />
              </Box>
              <button type="submit" className={styles.submitButton} disabled={isSubmitting}>
                {isSubmitting ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
              </button>
              <div className={styles.registerLink}>
                Şifrenizi Mi Unuttunuz? <Link to="/forgot-password">Sıfırla</Link>
              </div>
              <div className={styles.registerLink}>
                Hesabınız yok mu? <Link to="/register">Kayıt Ol</Link>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
